import { Component, ReactNode } from "react";

export type ErrorInfo = {
    componentStack: string;
};

export type CaughtError = {
    error: Error;
    info: ErrorInfo;
};

export type Props = {
    children: ReactNode;
    onError: (error: Error) => void;
};

type State = {
    caughtError: CaughtError | null;
};

export default class ErrorBoundary extends Component<Props, State> {
    public static defaultProps: Props = {
        children: null,
        onError: () => undefined
    };

    public static getDerivedStateFromError(
        error: Error
    ): Partial<State> | null {
        return {
            caughtError: { error, info: { componentStack: "" } }
        };
    }

    public override state = {
        caughtError: null
    };

    public override componentDidCatch(error: Error, info: ErrorInfo) {
        const { onError } = this.props;
        this.setState({ caughtError: { error, info } });
        onError(error);
    }

    public override render() {
        const { caughtError } = this.state;
        const { children } = this.props;

        if (!caughtError) {
            return children;
        }

        return null;
    }
}
